import type { SVGProps } from 'react';
const SvgIconAlert = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M8 5.5c.41 0 .738.34.723.75l-.076 2.125a.648.648 0 0 1-1.294 0L7.277 6.25A.724.724 0 0 1 8 5.5m0 6A.75.75 0 1 0 8 10a.75.75 0 0 0 0 1.5"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m10.57 2.859 4.273 7.093c1.205 2-.235 4.548-2.57 4.548H3.727c-2.335 0-3.775-2.549-2.57-4.548L5.43 2.859c1.167-1.936 3.973-1.936 5.14 0m-1.285.774a1.5 1.5 0 0 0-2.57 0l-4.273 7.093A1.5 1.5 0 0 0 3.727 13h8.546a1.5 1.5 0 0 0 1.285-2.274z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconAlert;
